// @ts-expect-error legacy
import Formatter from "@/legacy/Formatter";

interface AuditDetailsValue {
  val: unknown;
  valueType?: unknown;
}

export const AuditDetailsValue = ({val, valueType}: AuditDetailsValue) => {
  // all types of details specified here: https://github.com/GoogleChrome/lighthouse/blob/master/types/lhr/audit-details.d.ts
  if (val === undefined) {
    return "";
  }
  if (valueType === "text") {
    return <>{val}</>;
  } else if (valueType === "numeric" && typeof val === "number") {
    //check if val is float
    if (!Number.isInteger(val)) {
      return <>{val.toFixed(2)}</>;
    } else {
      return <>{val}</>;
    }
  } else if (valueType === "ms") {
    if (typeof val === "number") {
      return <>{val.toFixed(2)}ms</>;
    } else {
      return <>{val}ms</>;
    }
  } else if (valueType === "code") {
    if (typeof val === "string") {
      return (
        <>
          <code>{val}</code>
        </>
      );
    } else {
      // @ts-expect-error unknown type
      const content = <AuditDetailsValue val={val} valueType={val.type} />;
      return <code>{content}</code>;
    }
  } else if (valueType === "source-location") {
    // @ts-expect-error unknown type
    const content = `${val.url}:${val.line}:${val.column}`;
    return <>{content}</>;
  } else if (valueType === "multi") {
    // @ts-expect-error unknown type
    const content = val.items.map((val) => <AuditDetailsValue val={val} />);
    return <>{content}</>;
  } else if (valueType === "thumbnail") {
    // @ts-expect-error unknown type
    const content = <img alt="thumbnail" src={val.data} />;
    return <>{content}</>;
  } else if (valueType === "link") {
    // @ts-expect-error unknown type
    const text = val.text;
    // @ts-expect-error unknown type
    const url = val.url;
    return (
      <a target="_blank" href={url}>
        {text}
      </a>
    );
  } else if (valueType === "url") {
    const href = val?.toString() || "";
    return (
      <>
        {val} [
        <a target="_blank" href={href}>
          open
        </a>
        ]
      </>
    );
  } else if (valueType === "timespanMs") {
    return Formatter.formatMs(val);
  } else if (valueType === "bytes") {
    return Formatter.humanBytes(val);
  } else if (valueType === "node") {
    // @ts-expect-error unknown type
    const valNode: {
      nodeLabel: string;
      selector: string;
      snippet: string;
    } = val;
    return (
      <>
        {valNode.nodeLabel} <code title={valNode.selector}>{valNode.snippet}</code>
      </>
    );
  }

  return <>{val?.toString()}</>;
};
